import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import GolfIcon from '../GolfIcon';
import { Achievement } from '@/types/achievements';
import { ProgressCircle } from '../ui/progress-circle';
import { AchievementDetailModal } from './AchievementDetailModal';

interface AchievementCardProps {
  achievement: Achievement;
  className?: string;
}

export const AchievementCard: React.FC<AchievementCardProps> = ({
  achievement,
  className
}) => {
  const { id, icon, title, description, earned, progress, total, level } = achievement;
  const [showDetailModal, setShowDetailModal] = useState(false);

  return (
    <div
      className={cn(
        "flex flex-col items-start p-4 w-full cursor-pointer",
        className
      )}
      onClick={() => setShowDetailModal(true)}
    >
      <div className="flex flex-col items-center">
        <div className="relative">
          <ProgressCircle
            value={progress}
            max={total}
            radius={32}
            strokeWidth={earned ? 4 : 4}
            variant={"success"}
            className="size-16 rounded-full"
          >
            <div className="relative">
              <img
                src={`/assets/images/badges/${icon}.webp`}
                alt={icon}
                className={cn("size-full p-2", !earned && "dark:invert grayscale opacity-40 brightness-0")}
              />
              {/* {!earned && (
                <div className="absolute inset-0 flex items-center justify-center m-1 rounded-full">
                  <GolfIcon name="lock" className="text-white size-5 z-10" />
                </div>
              )} */}
            </div>
          </ProgressCircle>
        </div>

        <h3 className="text-sm font-medium mt-2 text-center w-full">{title}</h3>
      </div>

      {/* Achievement Detail Modal */}
      <AchievementDetailModal
        achievement={achievement}
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
      />
    </div >
  );
};
